// extracted by mini-css-extract-plugin
module.exports = {"ContentBankItemWrapper":"MyMaterials_ContentBankItemWrapper__Vq-mJ","Select":"MyMaterials_Select__3haEw"};